import { lightboxes } from './lightboxes.js';
import { mobile } from './mobile.js';
import { nav } from './nav.js';
import { loader } from './loader.js';

const $j = (typeof window !== 'undefined' && window.$j) || (() => {});
const $ = $j;

(function (jq, _root) {
    const j = jq;
    j(function () {
        $('html').removeClass('no-js');
        lightboxes();
        mobile();
        nav();
        loader();
    });
})($j, undefined);
